import { FC, ReactNode } from 'react';
import { fareContainer } from '../styles';

interface FareContainerProps {
  children: ReactNode;
}

/**
 * Renders its children with the fare container style. Can be used
 * to wrap around both fare breakup and confirmation button
 */
const FareContainer: FC<FareContainerProps> = ({ children }) => {
  return <div css={fareContainer}>{children}</div>;
};

export default FareContainer;
